import React, { cloneElement, PropTypes } from 'react';
import B from 'bem-cn';
import { Tabs, Tab } from 'react-toolbox/lib/tabs';
import { Card, CardText } from 'react-toolbox/lib/card';

import './index.scss';

const cl = B('Tabs');

export default class TabsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: this.props.index || 0
    };

    this.changeTab = this.changeTab.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.index !== 'undefined' &&
      nextProps.index !== this.state.index
    ) {
      this.changeTab(nextProps.index);
    }
  }

  changeTab(idx) {
    this.setState({
      index: idx
    });

    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  getChildren() {
    let { children } = this.props;
    if (!Array.isArray(children)) {
      children = [children];
    }

    return children.map((item) => {
      const content = (<Card>
        <CardText>{item.props.children}</CardText>
      </Card>);
      return cloneElement(item, {}, content);
    });
  }

  render() {
    const { title, className = '' } = this.props;

    return (
      <div className={cl.mix(className)}>
        <div className={cl('header')}>
          {title && <div className={cl('title')}>{title}</div>}
        </div>

        <Tabs index={this.state.index} onChange={this.changeTab} fixed>
          {this.getChildren()}
        </Tabs>
      </div>
    );
  }
}

TabsContainer.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  items: PropTypes.array,
  index: PropTypes.number,
  children: PropTypes.array,
  className: PropTypes.string
};

export { Tab };



// WEBPACK FOOTER //
// ../src/components/tabs/index.jsx